export const category = {
  insType: [{
    value: 10, label: '商业险'}, {
    value: 11, label: '交强险'
  }],
  clauseType: [{
    // value: 0, label: '未知'}, {
    value: 1, label: '固定特约'}, {
    value: 2, label: '替换特约'}, {
    value: 3, label: '填空特约'}, {
    value: 4, label: '可选特约'
  }],
  addType: [{
    value: 0, label: '手动添加'}, {
    value: 1, label: '导入'
  }],
  appointSource: [{
    value: 0, label: '平台特约'}, {
    value: 1, label: '商户特约'
  }]
}

export default {
  category
}



// WEBPACK FOOTER //
// ./src/data/category.js